export default "__VITE_IMAGE_ASSET__02f343e1__";